import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_ADAS_IDS](state, data) {
    state.ids = data
  },
  [types.SET_ADASINSPECTION](state, data) {
    state.adasInspection = data
  },
  [types.SET_ADAS_MATRICES](state, data) {
    state.adasmatrices = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmatrices = data
        console.log('Storing to Session', state.adasmatrices)
        storage.session.setItem(types.SESSION_ADAS_MATRIX, JSON.stringify(state.adasmatrices))
      }
    }
  },
  [types.SET_LINKS](state, data) {
    state.links = data
    try {
      if (data) {
        if (Array.isArray(data)) {
          data.forEach(element => {
            if (element.links) {
              if (element.links !== null) {
                try {
                  element.links = JSON.parse(element.links)
                } catch (e) {
                  element.links = []
                }
              }
            }
          })
        } else {
          state.links = data
          if (state.links.links) {
            if (state.links.links !== null) {
              try {
                state.links.links = JSON.parse(state.links.links)
              } catch (e) {
                state.links.links = []
              }
            }
          }
        }
      }
    } catch (e) {
      console.log('Error (adas > mutations > Set Links)', e)
    }
    console.log('Got Links', state.links)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/mutations.js